module.exports = __webpack_public_path__ + "static/img/open-title-4.d12773f8.png";